import React from "react";
import StoreCreditRequestsComp from "../../components/Store/StoreCreditRequests";

export default function StoreCreditRequests() {
  return <StoreCreditRequestsComp />;
}
